import React, { useState } from 'react'
import { HiMail, HiGlobeAlt } from 'react-icons/hi'
import bernadette from '../images/schaf.png'
import vanessa from '../images/geflügel.png'
import markus from '../images/fisch.png'
import fhLogo from '../images/logo-icon.svg'
import styles from './ImpressumContent.module.css'

export const ImpressumContent = () => {
  const [eastereggB, setEastereggB] = useState(false);
  const [eastereggV, setEastereggV] = useState(false);
  const [eastereggM, setEastereggM] = useState(false);

  return (
    <>
      <h2 className={styles.heading}>Impressum<img src={fhLogo} alt="Logo FH Salzburg"/></h2>
      <p>
        Das Projekt ReGo wurde im Rahmen der Ausbildung, an der{' '}
        <a
          href="https://www.fh-salzburg.ac.at/"
          target="_blank"
          rel="noreferrer"
        >
          FH Salzburg
        </a>
        , als MMP2b erstellt.
      </p>
      <p>
        Alle Daten werden mit Ende der Ausbildung, im Sommer 2023, entgültig
        gelöscht.
      </p>
      <h3>Das ReGo Team</h3>
      <div className={styles.team}>
        {!eastereggB ? (
              <img onClick={() => setEastereggB(true)} src={bernadette} alt="Bernadette als Schaf" />
        ) : (
              <img onClick={() => setEastereggB(false)} src={fhLogo} alt="Logo FH Salzburg"/>
        )}
        <div>
          <h4>Bernadette Ackerl</h4>
          <h4>
            <a href="mailto:backerl.mmt-b2020@fh-salzburg.ac.at">
              <HiMail />
            </a>
            <a
              href="https://portfolio.fh-salzburg.ac.at/users/bernadette-ackerl"
              target="_blank"
              rel="noreferrer"
            >
              <HiGlobeAlt />
            </a>
          </h4>
        </div>
        {!eastereggV ? (
            <img onClick={() => setEastereggV(true)} src={vanessa} alt="Vanessa als Huhn" />
        ) : (
              <img onClick={() => setEastereggV(false)} src={fhLogo} alt="Logo FH Salzburg"/>
        )}
        <div>
          <h4>Vanessa Reiter</h4>
          <h4>
            <a href="mailto:vreiter.mmt-b2020@fh-salzburg.ac.at">
              <HiMail />
            </a>
            <a
              href="https://portfolio.fh-salzburg.ac.at/users/vanessa-stefanie-reiter"
              target="_blank"
              rel="noreferrer"
            >
              <HiGlobeAlt />
            </a>
          </h4>
        </div>
        {!eastereggM ? (
            <img onClick={() => setEastereggM(true)} src={markus} alt="Markus als Fisch" />
        ) : (
              <img onClick={() => setEastereggM(false)} src={fhLogo} alt="Logo FH Salzburg"/>
        )}
        <div>
          <h4>Markus Rinnerberger</h4>
          <h4>
            <a href="mailto:mrinnerberger.mmt-b2020@fh-salzburg.ac.at">
              <HiMail />
            </a>
            <a
              href="https://portfolio.fh-salzburg.ac.at/users/markus-rinnerberger"
              target="_blank"
              rel="noreferrer"
            >
              <HiGlobeAlt />
            </a>
          </h4>
        </div>
      </div>
    </>
  )
}
